import { Form, Input, InputNumber, Space, Checkbox } from "antd";
import WrappingModal from "../../../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل العملة" : "إضافة عملة"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleOk}
      >
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {isEditing && (
              <Form.Item
                name="CurrID"
                label="كود العملة"
                rules={[{ required: true, message: "الرجاء إدخال كود العملة" }]}
              >
                <InputNumber
                  placeholder="كود العملة"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}
            <Form.Item
              name="CurrName"
              label="اسم العملة"
              rules={[{ required: true, message: "الرجاء إدخال اسم العملة" }]}
            >
              <Input placeholder="اسم العملة" className="w-full" />
            </Form.Item>
            <Form.Item name="CurrPart" label="جزء العملة">
              <Input placeholder="جزء العملة" className="w-full" />
            </Form.Item>
            <Form.Item
              name="CurrRate"
              label="سعر الصرف"
              rules={[{ required: true, message: "الرجاء إدخال سعر الصرف" }]}
            >
              <InputNumber className="w-full" placeholder="سعر الصرف" />
            </Form.Item>
            <Form.Item name="IsDefualte" valuePropName="checked">
              <Checkbox>العملة الافتراضية</Checkbox>
            </Form.Item>
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
